<template>
  <div class="row mx-0">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="p-0 m-0 mt-4 main-title">入料參數查詢</div>
      <div style="margin-top: 2rem">
        <commonQueryInput
          :inputItems="multiInputItems"
          :immediateInputValues="true"
          v-model:getValue="multiInputVal"
          v-model:getImmediateValue="immediateMultiInputVal"
        ></commonQueryInput>
      </div>
      <div style="margin-top: 2rem">
        <queryResultTable
          :dateHour="true"
          :queryResultTableItems="queryResultTableItems"
        />
      </div>
      <div class="text-end my-3">
        <exportCsv
          :exportData="feedInquireItems"
          :exportDataTitle="feedInquireFields.map((item) => item.label)"
          :exportFileName="exportFileName()"
        />
      </div>
      <commonTable
        :fields="feedInquireFields"
        :items="feedInquireItems"
        :theme="'green'"
        stickyHeader="270px"
        style="margin-bottom: 2rem"
      >
      </commonTable>
    </div>
    <div class="col-1"></div>
  </div>
</template>
  
  <script>
import commonQueryInput from "@/components/commonQueryInput.vue";
import queryResultTable from "@/components/queryResultTable.vue";
import stackBar from "@/components/stackBar.vue";
import exportCsv from "@/components/exportCsv.vue";
import commonTable from "@/components/commonTable.vue";
import { computed, inject, ref, watch } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    commonQueryInput,
    queryResultTable,
    stackBar,
    exportCsv,
    commonTable,
  },
  setup() {
    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const oper = computed(() => store.getters["selectOptions/get_htProcess"]);
    const device = computed(() => store.getters["selectOptions/get_device"]);

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
      set_device: (payload) => {
        store.dispatch("selectOptions/set_device", payload);
      },
    };

    const path = inject("path");
    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "date",
        label: "日期",
        type: "date", // date/dateBetween/text/select/time/month
      },
      {
        key: "time",
        label: "時間",
        type: "timeBetween",
        checkEmpty: true,
      },
      {
        key: "oper",
        label: "製程",
        type: "select",
        checkEmpty: true,
        disableText: "-- 選擇製程 --",
        options: oper,
      },
      {
        key: "deviceID",
        label: "機台",
        type: "select",
        bindKey: "oper",
        checkEmpty: false,
        disableText: "-- 選擇機台 --",
        bindOptions: device,
      },
    ]);
    const immediateMultiInputVal = ref();

    //查詢結果表格資料
    const queryResultTableItems = ref([]);

    //熱處理參數資訊
    const feedInquireFields = [
      {
        key: "time",
        label: "時間",
        sortable: true,
        thStyle: {
          "min-width": "80px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "speed_set",
        label: "速度",
        sortable: true,
        thStyle: {
          "min-width": "80px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "each_weight",
        label: "單次重",
        sortable: true,
        thStyle: {
          "min-width": "110px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "weight",
        label: "總重",
        sortable: true,
        thStyle: {
          "min-width": "110px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "weight_set",
        label: "設定重量",
        sortable: true,
        thStyle: {
          "min-width": "110px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "slow_weight",
        label: "慢速重量",
        sortable: true,
        thStyle: {
          "min-width": "110px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const feedInquireItems = ref([]);

    //匯出資料的檔案名稱
    const exportFileName = () => {
      let exportFileName = "";
      if (feedInquireItems.value.length != 0) {
        exportFileName =
          "入料參數查詢_" +
          queryResultTableItems.value[0].date +
          "_" +
          (queryResultTableItems.value[0].time == "-"
            ? ""
            : queryResultTableItems.value[0].time + "_") +
          (queryResultTableItems.value[0].oper == "-"
            ? ""
            : queryResultTableItems.value[0].oper + "_") +
          (queryResultTableItems.value[0].device == "-"
            ? ""
            : queryResultTableItems.value[0].device);
      }
      return exportFileName;
    };

    //watch 按查詢鍵回傳所有輸入框的值
    watch(
      multiInputVal,
      (newValue) => {
        methods.triggerLoadingBar();
        let params = {};
        params["webPage"] =
          sideNavPath.value.length != 0
            ? sideNavPath.value[sideNavPath.value.length - 1]
            : null;
        params["user"] = loginData.value.account;
        params["vuePage"] = path.value;
        console.log(path.value);
        console.log(newValue);
        params["methods"] = "POST";
        params["whichFunction"] = "feedInquire";
        params["startTime"] = newValue["date"]["startDate"];
        params["startMinTime"] = newValue["time"]["startTime"];
        params["endMinTime"] = newValue["time"]["endTime"];
        params["oper"] = newValue["oper"];
        newValue["deviceID"] != undefined
          ? (params["deviceID"] = newValue["deviceID"])
          : "";

        methods.axiosAction(params).then(() => {
          console.log(axiosResult.value);
          let result = axiosResult.value;
          let response = result.Response;
          if (response == "ok") {
            let queryTableData = result.QueryTableData;
            queryResultTableItems.value = [
              {
                date: queryTableData.information[0].date,
                time: queryTableData.information[0].time,
                site: queryTableData.information[0].factory,
                oper: queryTableData.information[0].process,
                group: queryTableData.information[0].group,
                device: queryTableData.information[0].device,
              },
            ];
            feedInquireItems.value = queryTableData.value;
          } else {
            queryResultTableItems.value = [];
            feedInquireItems.value = [];
            methods.setTimeoutAlert(response);
          }
          methods.triggerLoadingBar();
        });
      },
      { deep: true }
    );

    const startTime = ref("");
    const process = ref("");
    // 查詢機台
    watch(
      immediateMultiInputVal,
      (newValue) => {
        if (newValue.oper == "" || newValue.oper == null) {
          return;
        }
        if (process.value == newValue.oper) {
          return;
        }
        let params = {};
        params["user"] = loginData.value.account;
        params["vuePage"] = "selectoption";
        params["methods"] = "GET";
        params["whichFunction"] = "GetDeviceOption";
        if (newValue.oper != "" || newValue.oper != null) {
          params["process"] = newValue.oper;
        } else {
          params["process"] = "-";
        }
        methods.axiosAction(params).then(() => {
          let result = axiosResult.value;
          if (result["Response"] == "ok") {
            methods.set_device(result.QueryTableData.device);
            process.value = newValue.oper;
          } else {
            let returnData = {};
            returnData[params.process] = [];
            methods.set_device(returnData);
            startTime.value = "";
            process.value = "";
          }
        });
      },
      { deep: true }
    );

    return {
      multiInputVal,
      multiInputItems,
      immediateMultiInputVal,
      queryResultTableItems,
      feedInquireFields,
      feedInquireItems,
      exportFileName,
    };
  },
};
</script>
  
  <style scoped>
.ht-work-value-table {
  width: 100%;
  min-width: 900px;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #000;
}

.ht-work-value-table td {
  vertical-align: middle !important;
  border: 1px solid #000;
}

.ht-work-value-table tr:nth-child(odd) {
  color: #4b8c80;
  background-color: #ffffff;
}

.ht-work-value-table tr:nth-child(even) {
  background-color: #f0f0f0;
}

.ht-work-value-table thead th {
  padding: 5px;
  font-size: 1rem;
  color: #ffffff;
  background-color: #4b8c80;
  border: 1px solid #000;
  writing-mode: vertical-rl;
  text-orientation: upright;
  vertical-align: middle !important;
  min-width: 30px;
}

.sticky-thead {
  position: sticky;
  top: 0;
}
</style>
  